import React, { useRef } from 'react';
import {
  Line,
  Bar,
  Pie,
  Doughnut,
  Radar,
  PolarArea,
} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale
);

const ChartSection = ({ chartType, chartColumns, columnColors, parsedData, labelChart, formTitle }) => {
  const chartRef = useRef(null);

  // Extract labels from data
  const labels = parsedData.map(entry => entry[labelChart || 'Name']);

  // Generate colors per data point (useful for Pie/Doughnut/PolarArea)
  const generateColors = (length) => {
    const palette = [
      '#FF6384', '#36A2EB', '#FFCE56',
      '#4BC0C0', '#9966FF', '#FF9F40',
      '#00A36C', '#FF6F91', '#845EC2',
      '#008F7A', '#FFC75F', '#F9F871'
    ];
    return Array.from({ length }, (_, i) => palette[i % palette.length]);
  };

  // Prepare data based on chart type
  const isCircularChart = ['pie', 'doughnut', 'polararea'].includes(chartType.toLowerCase());

  const chartData = {
    labels,
    datasets: isCircularChart
      ? chartColumns.map(col => ({
          label: col,
          data: parsedData.map(entry => entry[col]),
          backgroundColor: generateColors(parsedData.length),
          borderColor: '#fff',
          borderWidth: 1,
        }))
      : chartColumns.map(col => ({
          label: col,
          data: parsedData.map(entry => entry[col]),
          borderColor: columnColors[col] || '#000',
          backgroundColor: columnColors[col] || '#000',
          fill: false,
        })),
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}`,
        },
      },
    },
  };

  // const downloadChart = () => {
  //   const chart = chartRef.current;
  //   if (!chart) return;

  //   const url = chart.toBase64Image(); // Get image
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = `chart-${chartType}.png`;
  //   link.click();
  // };

  const downloadChart = () => {
    const chart = chartRef.current;
    if (!chart) return;
  
    const canvas = chart.canvas;
  
    // Create a new white background image from the chart canvas
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
  
    // Create an off-screen canvas to apply white background
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    tempCanvas.width = width;
    tempCanvas.height = height;
  
    // Draw white background
    tempCtx.fillStyle = '#ffffff';
    tempCtx.fillRect(0, 0, width, height);
  
    // Draw the existing chart onto the white background
    tempCtx.drawImage(canvas, 0, 0);
  
    // Download the final image
    const url = tempCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = `EmyLab-${formTitle}-chart-${chartType}.png`;
    link.click();
  };

  // Render chart based on type
  const renderChart = () => {
    const chartCommonProps = {
      data: chartData,
      options,
      ref: chartRef, // <-- This is needed for downloading the chart
    };
  
    switch (chartType.toLowerCase()) {
      case 'line':
        return <Line {...chartCommonProps} />;
      case 'bar':
        return <Bar {...chartCommonProps} />;
      case 'pie':
        return <Pie {...chartCommonProps} />;
      case 'doughnut':
        return <Doughnut {...chartCommonProps} />;
      case 'radar':
        return <Radar {...chartCommonProps} />;
      case 'polararea':
        return <PolarArea {...chartCommonProps} />;
      default:
        return <p>Please select a valid chart type.</p>;
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {renderChart()}
      <button onClick={downloadChart} style={{ marginTop: '1rem' }}>
        Download Chart
      </button>
    </div>
  );

  // return (
  //   <div>
  //     {renderChart()}
  //     <button onClick={downloadChart} style={{ marginTop: '1rem' }}>
  //       Download Chart
  //     </button>
  //   </div>
  // );
};

export default ChartSection;
